"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CasinoWidgetImgSrcEnum = exports.CasinoFilterTypeEnum = exports.CasinoWidgetFolderEnum = exports.CasinoSectionsStyleEnum = exports.CasinoSectionsEnum = exports.CasinoGameTypeEnum = exports.PROVIDERS_ICONS_MAP = exports.PROVIDERS_LOGO_MAP = void 0;
const casinoProviders_1 = require("./casinoProviders");
exports.PROVIDERS_LOGO_MAP = {
    [casinoProviders_1.ProvidersEnum.PRAGMATIC]: "pragmatic-banner",
    [casinoProviders_1.ProvidersEnum.EVOLUTION]: "evolution-banner",
    [casinoProviders_1.ProvidersEnum.NETENT]: "netent-banner",
    [casinoProviders_1.ProvidersEnum.PGSOFT]: "pgsoft-banner",
    [casinoProviders_1.ProvidersEnum.EVOPLAY]: "evoplay-banner",
    [casinoProviders_1.ProvidersEnum.SPRIBE]: "spribe-banner",
};
exports.PROVIDERS_ICONS_MAP = {
    [casinoProviders_1.ProvidersEnum.PRAGMATIC]: "pragmatic-play",
    [casinoProviders_1.ProvidersEnum.EVOLUTION]: "evolution-gaming",
    [casinoProviders_1.ProvidersEnum.NETENT]: "netent",
    [casinoProviders_1.ProvidersEnum.PGSOFT]: "pgsoft",
    [casinoProviders_1.ProvidersEnum.EVOPLAY]: "evoplay",
    [casinoProviders_1.ProvidersEnum.SPRIBE]: "spribe",
};
var CasinoGameTypeEnum;
(function (CasinoGameTypeEnum) {
    CasinoGameTypeEnum["LIVE_CASINO"] = "livecasino";
    CasinoGameTypeEnum["LIVE_CASINO_V2"] = "Live Casino";
    CasinoGameTypeEnum["LIVE_CASINO_TABLE"] = "live-casino-table";
    CasinoGameTypeEnum["VIDEO_SLOTS"] = "video-slots";
    CasinoGameTypeEnum["TABLE_GAMES"] = "table-games";
    CasinoGameTypeEnum["FAST_GAMES"] = "fast-games";
    CasinoGameTypeEnum["CRASH_GAMES"] = "crash-games";
    CasinoGameTypeEnum["VIDEO_BINGO"] = "video-bingo";
    CasinoGameTypeEnum["VIDEO_POKER"] = "video-poker";
    CasinoGameTypeEnum["SCRATCH_CARDS"] = "scratch-cards";
    CasinoGameTypeEnum["VIRTUAL_GAMES"] = "virtual-games";
    CasinoGameTypeEnum["VIRTUAL_SPORTS"] = "virtual-sports";
    CasinoGameTypeEnum["LIVE_GAMES"] = "livegames";
})(CasinoGameTypeEnum || (exports.CasinoGameTypeEnum = CasinoGameTypeEnum = {}));
var CasinoSectionsEnum;
(function (CasinoSectionsEnum) {
    CasinoSectionsEnum["Banners"] = "banners";
    CasinoSectionsEnum["LiveCasino"] = "livecasino";
    CasinoSectionsEnum["Reels"] = "reels";
    CasinoSectionsEnum["Slots"] = "slots";
    CasinoSectionsEnum["Winners"] = "winners";
    CasinoSectionsEnum["GameInfo"] = "game_info";
    CasinoSectionsEnum["All"] = "all";
})(CasinoSectionsEnum || (exports.CasinoSectionsEnum = CasinoSectionsEnum = {}));
var CasinoSectionsStyleEnum;
(function (CasinoSectionsStyleEnum) {
    CasinoSectionsStyleEnum["Row"] = "row";
    CasinoSectionsStyleEnum["WideRow"] = "wide_row";
    CasinoSectionsStyleEnum["NarrowRow"] = "narrow_row";
    CasinoSectionsStyleEnum["RoundRow"] = "round_row";
    CasinoSectionsStyleEnum["MiniRow"] = "mini_row";
    CasinoSectionsStyleEnum["Shop"] = "shop";
    CasinoSectionsStyleEnum["Mosaic"] = "mosaic";
    CasinoSectionsStyleEnum["MosaicMix"] = "mosaic_mix";
    CasinoSectionsStyleEnum["MosaicRain"] = "mosaic_rain";
    CasinoSectionsStyleEnum["Narrow"] = "narrow";
})(CasinoSectionsStyleEnum || (exports.CasinoSectionsStyleEnum = CasinoSectionsStyleEnum = {}));
var CasinoWidgetFolderEnum;
(function (CasinoWidgetFolderEnum) {
    CasinoWidgetFolderEnum["Default"] = "default";
    CasinoWidgetFolderEnum["Central"] = "central";
})(CasinoWidgetFolderEnum || (exports.CasinoWidgetFolderEnum = CasinoWidgetFolderEnum = {}));
var CasinoFilterTypeEnum;
(function (CasinoFilterTypeEnum) {
    CasinoFilterTypeEnum["Tag"] = "tag";
    CasinoFilterTypeEnum["Prop"] = "prop";
    CasinoFilterTypeEnum["Type"] = "type";
})(CasinoFilterTypeEnum || (exports.CasinoFilterTypeEnum = CasinoFilterTypeEnum = {}));
var CasinoWidgetImgSrcEnum;
(function (CasinoWidgetImgSrcEnum) {
    CasinoWidgetImgSrcEnum["Image"] = "image";
    CasinoWidgetImgSrcEnum["ImagePreview"] = "image_preview";
    CasinoWidgetImgSrcEnum["ImageFilled"] = "image_filled";
    CasinoWidgetImgSrcEnum["ImageBackground"] = "image_background";
    CasinoWidgetImgSrcEnum["ImagePortrait"] = "image_portrait";
    CasinoWidgetImgSrcEnum["ImageSquare"] = "image_square";
})(CasinoWidgetImgSrcEnum || (exports.CasinoWidgetImgSrcEnum = CasinoWidgetImgSrcEnum = {}));
//# sourceMappingURL=casino.js.map